module.exports = __webpack_public_path__ + "static/media/money2.d3535760.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/money2.png
// module id = 664
// module chunks = 0 1